import isBefore from 'date-fns/isBefore';

import { fg } from '@atlaskit/platform-feature-flags';

import type { ActivityEnrichment } from '../../../../../common/ui/quick-find/types';

import { type RecommendedEventType, RecommendedType } from './types';

/**
 * Resolves which timestamp to display for a recommended document.
 *
 * Uses the activity timestamp when the recommendation is a "You …" type
 * (`no_collaborator`), the event type from the recommendation matches the
 * activity event type, and the activity timestamp is more recent.
 * Otherwise falls back to the recommendation timestamp.
 */
export const resolveDisplayTimestamp = (
	recommendedType: RecommendedType | string,
	recommendedEventType: RecommendedEventType | string,
	recommendedTimestamp: string,
	activityEnrichment: ActivityEnrichment | undefined,
): string => {
	if (
		activityEnrichment &&
		recommendedType === RecommendedType.NO_COLLABORATOR &&
		recommendedEventType === activityEnrichment.eventType &&
		fg('qf_override_stale_recommendation_timestamp')
	) {
		if (
			!recommendedTimestamp ||
			isBefore(new Date(recommendedTimestamp), new Date(activityEnrichment.timestamp))
		) {
			return activityEnrichment.timestamp;
		}
	}
	return recommendedTimestamp;
};
